import { nanoid } from 'nanoid';
import Yup from 'utils/validation/yup-extensions';

/**
 * Application ID for Epic HP
 */
export const HP_APP_ID = 1696;

/**
 * T_Component FI_ID for the "form" component.
 */
export const HP_COMPONENT_ID = 6100;

/**
 * Maximum selection counts
 */
export const MAX_COUNTS = {
	JOB_CATEGORIES: 7,
};

/**
 * Keys to be used by Formik
 */
export const HP_FIELD_KEYS = {
	JOB_CATEGORIES: 'jobCategories',
};

export const DEFAULT_VALUES = {
	[HP_FIELD_KEYS.JOB_CATEGORIES]: {
		jobCategoryId: nanoid(),
		jobCategoryName: null,
		jobCategoryType: null,
		active: true,
	},
};

export const VALIDATION_SCHEMA = Yup.object().shape({
	[HP_FIELD_KEYS.JOB_CATEGORIES]: Yup.array()
		.of(
			Yup.object()
				.shape({
					jobCategoryId: Yup.mixed(),
					jobCategoryName: Yup.string()
						.test(
							'active-job-category-name',
							'Please select a job category.',
							function (value) {
								if (this.parent?.active === false) {
									return true;
								}
								return !!String(value ?? '').trim();
							},
						)
						.nullable(),
					jobCategoryType: Yup.string().nullable(),
				})
				.default(null)
				.nullable(),
		)
		.min(1, 'You must have at least one job category.')
		.max(
			MAX_COUNTS.JOB_CATEGORIES,
			`You can select no more than ${MAX_COUNTS.JOB_CATEGORIES} job categories.`,
		)
		.test('enhancement count', async function (value) {
			if (value && value.length > 0) {
				const activeJobCategories = value.filter(
					jc => jc?.active !== false,
				);

				const primaryJCs = activeJobCategories.filter(
					jc =>
						jc?.jobCategoryType?.toLowerCase() ===
						'primary category',
				);
				const enhancementJCs = activeJobCategories.filter(
					jc =>
						jc?.jobCategoryType?.toLowerCase() ===
						'enhancement category',
				);
				if (enhancementJCs.length > 0 && primaryJCs.length === 0) {
					return this.createError({
						message:
							'You must have at least one primary job category',
					});
				}
			}
			return true;
		}),
});
